import React, { useState } from 'react';
import './style.css'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AnalyticsSolutions = () => {

    const [activeTab, setActiveTab] = useState(0);

    const { t } = useTranslation("analyticsSolutionContent")
    const analyticsData = t("analyticsDataCards", { returnObjects: true })
    const analyticsDataContent = t("analyticsDataContent", { returnObjects: true })


    return (
        <>
            <div className="analytics-solutions-box">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 space-bottom-box">
                            <div className="analytics-textbox-border">
                                <h1>{analyticsDataContent?.mainHeading} <span>{analyticsDataContent?.greenHeading}</span></h1>
                                <p className="common-text">{analyticsDataContent?.sectionDescription}</p>
                            </div>

                            <div className="container-fluid">
                                <div className="row">
                                    {analyticsData.map((item, index) => (
                                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6" key={index}>
                                            <div
                                                className={`analytics-image-box ${index === activeTab ? 'active-tab' : ''}`}
                                                onClick={() => setActiveTab(index)}
                                            >
                                                <img src={`/images/anylatics-icons/${item.icon}`} alt={`${item.icon}`} />
                                                <h3>{item.title}</h3>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="crm-analytics-box">
                                <div className="crm-icon-box">
                                    <img src={`/images/anylatics-icons/${analyticsData[activeTab].icon}`} alt={`${analyticsData[activeTab].icon}`} />
                                </div>

                                <h2>{analyticsData[activeTab].title}</h2>

                                <p>{analyticsData[activeTab].description}</p>

                                <div className="explor-industries-btn">
                                    <Link to="/Industries">{analyticsDataContent?.buttonText} <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AnalyticsSolutions